export const PROFILES = ['Corretor','Gerente','Master']
